import { ByDateDimension, ByRangeDimension, BySeedProductDimension } from 'types';

export function calcAvgMoisture(moisture: number, wetMass: number) {
  return {
    q: wetMass ? (moisture / wetMass) * 100 : 0,
    u: 'percent',
  };
}

function extractMin(label: string) {
  if (label.startsWith('>')) {
    return Infinity;
  }

  if (label.startsWith('<')) {
    return -Infinity;
  }

  const minRangeMatch = label.match(/[\d.]+/);

  return minRangeMatch && minRangeMatch.length > 0 ? parseFloat(minRangeMatch[0]) : -Infinity;
}

interface LabelObject {
  label: string;
}

export function sortDescDataByLabelRanges(item1: LabelObject, item2: LabelObject): number {
  const minItem1 = extractMin(item1.label);
  const minItem2 = extractMin(item2.label);

  if (minItem1 < minItem2) return 1;
  if (minItem1 > minItem2) return -1;
  return 0;
}

export function sortDescRange(item1: ByRangeDimension, item2: ByRangeDimension): number {
  const minItem1 = item1.min ?? 0;
  const minItem2 = item2.min ?? 0;

  if (minItem1 < minItem2) return 1;
  if (minItem1 > minItem2) return -1;
  return 0;
}

export function sortDescDate(item1: ByDateDimension, item2: ByDateDimension): number {
  if(item1.date === null && item2.date === null) return 0;
  if(item1.date === null) return 1;
  if(item2.date === null) return -1;

  const date1 = new Date(item1.date).getTime();
  const date2 = new Date(item2.date).getTime();

  if (date1 < date2) return 1;
  if (date1 > date2) return -1;
  return 0;
}

export function sortDescSeedProducts(item1: BySeedProductDimension, item2: BySeedProductDimension): number {
  const name1 = item1.seedProduct?.name || item1.seedProduct.id;
  const name2 = item2.seedProduct?.name || item2.seedProduct.id;
  return name1.localeCompare(name2);
}

export function sortDescDataByLabel(item1: LabelObject, item2: LabelObject): number {
  return item2.label.localeCompare(item1.label);
}

export function parseAppliedApplicationsData(data) {
  return data.map((application) => ({
    area: application.appliedYield.area,
    averageYield: application.appliedYield.averageYield,
    label: application.applicationPassName,
    ...application
  }))
}